import script from "./profileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./profileModal.vue?vue&type=script&setup=true&lang=js"

import "./profileModal.vue?vue&type=style&index=0&id=217c825c&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217c825c"]])

export default __exports__